const deleteNullKeys = <T extends { [key: string]: string | null }>(obj: T) => {
  const newObj = { ...obj };
  Object.keys(obj).forEach(item => {
    if (obj[item] === null) {
      delete newObj[item];
    }
  });
  return newObj;
};

export default deleteNullKeys;
